import React from 'react';
import {
  MDBFooter,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBIcon,
  MDBBtn
} from 'mdb-react-ui-kit';

export default function Footer() {
  return ( 
    <MDBFooter className='bg-dark text-center text-white'>
      <MDBContainer className='p-4 pb-0'>
        <section className='mb-4'>
          <MDBBtn outline color="light" floating className='m-1' href='https://www.facebook.com/profile.php?id=61564046068869' role='button'>
            <MDBIcon fab icon='facebook-f' />
          </MDBBtn>

          

          
          <MDBBtn outline color="light" floating className='m-1' href='https://www.instagram.com/baig_tech/' role='button'>
            <MDBIcon fab icon='instagram' />
          </MDBBtn>

          <MDBBtn outline color="light" floating className='m-1' href='#!' role='button'>
            <MDBIcon fab icon='linkedin-in' />
          </MDBBtn>

          
        </section>
      </MDBContainer>

      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        © 2020 Copyright:
        <a className='text-white' href=''>
          Baigtech.com
        </a>
        <div className='email text-start'>
        <a className='wh' href='mailto:baigtechcompany@gmail.com'>baigtechcompany@gmail.com</a>
        </div>
      </div>
    </MDBFooter>
  );
}
